import { pageData } from "../constants/pagedata";

const SHORT_TITLES=["animals","animals2","bathroom","body","buildings","clothes","clothes2","colors","computer","countries","food","food2","food3","garden","home","home2","hospital","jobs","jobs2","kitchen","letters","music","nature","numbers","personal","places","sports","stationery","subjects","things","transport"];

const LONG_TITLES=["verbs1","verbs2","verbs3","verbs4","verbs5","verbs6","verbs7","verbs8","verbs9","verbs10","likes","havehas","cancant","time","clothes","countries","uses","positions","isare","hisher","compare1","compare2","places","kinds","goingto","ifthen","clauses","feelings"];

const GRAMMAR_BUBBLES_TITLES=['Subject-Verb','Pronouns','Plurals'];

const BORDER_STYLE:string='solid 2px #fff';
const BORDER_STYLE_GREY:string='solid 2px #ddd';
const BORDER_STYLE_SELECTED:string='solid 2px #fc0';

const BACKGROUND_POS_OFFSET:number=-82;
const COLS_IN_SPRITE_SHORT:number=11;
const COLS_IN_SPRITE_LONG:number=10;

//contentGroups
//0 - none
//1 - shortContent with userContent
//2 - longContent
//3 - shortContent no userContent
//4 - grammarBubbles

interface PropsType{pageSelected:string, contentClick:(content: string[]) => void, userContentList:string[], contentSelected:string[]}
interface ChildPropsTypes{contentGroup:number, pageSelected:string, contentClick:(content: string[]) => void, userContentList:string[], contentSelected:string[]}

export const ContentPicker=function(props:PropsType){
    let contentGroup=0;
	if(props.pageSelected!=='')contentGroup=pageData[props.pageSelected].contentGroup;
	if(contentGroup===0)return null;
    
	return(
		<div>
			<DefaultContent	contentGroup={contentGroup} {...props} />
			<UserContent contentGroup={contentGroup} {...props} />
			<GrammarBubblesContent 	contentGroup={contentGroup}  {...props} />
		</div>
	)
}

const DefaultContent=function(props:ChildPropsTypes){
    if(props.contentGroup===0)return null;//0 - none
    if(props.contentGroup===4)return null;//4 - grammarBubbles

    //short content - //1 - shortContent with userContent or //3 - shortContent no userContent
    let useTitles=SHORT_TITLES;
    let myClassName='teachers-contentpicker-item';
    let colsInSprite=COLS_IN_SPRITE_SHORT;
    let contentType='site';

    //long content - //2 - longContent
    if(props.contentGroup===2){
        useTitles=LONG_TITLES;
        myClassName='teachers-contentpicker-longitem';
        colsInSprite=COLS_IN_SPRITE_LONG;
        contentType='site-long';
    }

    const contentBits=useTitles.map((contentTitle,index)=>{
        let isSelected=false;
        if(props.contentSelected[1]==='site'||props.contentSelected[1]==='site-long'){
            if(contentTitle===props.contentSelected[0])isSelected=true;
        }
        let myBorder=isSelected?BORDER_STYLE_SELECTED:BORDER_STYLE;
        let xPos=(index%colsInSprite)*BACKGROUND_POS_OFFSET;
        let yPos=(Math.floor(index/colsInSprite))*BACKGROUND_POS_OFFSET;
        let myStyle={ backgroundPositionX:xPos, backgroundPositionY:yPos, border:myBorder };
        return(
            <div 
                onClick={()=>{props.contentClick([contentTitle, contentType]);}} 
                key={contentTitle} 
                style={myStyle} 
                className={myClassName}>
            </div>
        );
    });
    return(
        <div id='teachers-contentpicker'>
            <p>Site content</p>
            {contentBits}
        </div>
    );
};

const UserContent=function(props:ChildPropsTypes){
    if(props.contentGroup!==1)return null;
    if(props.userContentList.length===0)return null;
    const userBits=props.userContentList.map((userTitle,index)=>{
        let isSelected=props.contentSelected[1]==='user'&&userTitle===props.contentSelected[0];
        let myStyle={border:isSelected?BORDER_STYLE_SELECTED:BORDER_STYLE_GREY};
        return(
            <li 
                style={myStyle} 
                onClick={()=>{props.contentClick([userTitle, 'user']);}} 
                key={userTitle}
            >
                {userTitle}
            </li>
        );
    });
    return(
        <div>
            <p>Your content</p>
            <ul className='teachers-contentpicker-user'>
                {userBits}
            </ul>
        </div>
    );
};

const GrammarBubblesContent=function(props:ChildPropsTypes){
    if(props.contentGroup!==4)return null;
    const grammarBubblesBits=GRAMMAR_BUBBLES_TITLES.map((title,index)=>{
        let myTitle=title.toLowerCase();
        let isSelected=props.contentSelected[1]==='gbubs'&&myTitle===props.contentSelected[0];
        let myStyle={border:isSelected?BORDER_STYLE_SELECTED:BORDER_STYLE_GREY};
        return(
            <li 
                style={myStyle} 
                onClick={()=>{props.contentClick([myTitle, 'grammarbubbles']);}} 
                key={myTitle}
            >
                {myTitle}
            </li>
        );
    });
    return(
        <div>
            <ul className='teachers-contentpicker-gbubs'>
                {grammarBubblesBits}
            </ul>
        </div>
    );
};